import { GET_COLOR_PALETTE_BLOCK_BY_ID_M } from "./blocks/colorPaletteBlockById.query";
import { GET_FAQ_BLOCK_BY_ID_M } from "./blocks/faqBlockById.query";
import { GET_FILEBLOCK_BY_ID_M } from "./blocks/fileBlockById.query";
import { GET_FORM_BLOCK_BY_ID_M } from "./blocks/formBlockById.query";
import { GET_ACCORDION_BLOCK_BY_ID_M } from "./blocks/getAccordionBlockById.query";
import { GET_AUDIENCES_M } from "./blocks/getAudiences.query";
import { GET_BANNERBLOCK_BY_ID_M } from "./blocks/getBannerBlockById.query";
import { GET_CONTACTBLOCK_BY_ID_M } from "./blocks/getContactBlockById.query";
import { GET_CONTACT_US_BLOCK_BY_ID_M } from "./blocks/getContactUsBlockById.query";
import { GET_FAQLISTBLOCK_BY_ID_M } from "./blocks/getFAQListBlockById.query";
import { GET_FILELISTBLOCK_BY_ID_M } from "./blocks/getFileListBlock.query";
import { GET_IMAGE_BLOCK_BY_ID } from "./blocks/getImageBlockById.query";
import { GET_INSURANCE_PICKER_BLOCK_BY_ID_M } from "./blocks/getInsurancePickerBlockById.query";
import { GET_LINK_TEASER_BLOCK_BY_ID_M } from "./blocks/getLinkTeaserBlockById.query";
import { GET_LISTBLOCK_BY_ID_M } from "./blocks/getListBlockById.query";
import { GET_ORDERBLOCK_BY_ID_M } from "./blocks/getOrderBlockById.query";
import { GET_PAGE_BY_ID_M } from "./blocks/getPageById.query";
import { GET_PAYMENTDAYSBLOCK_BY_ID_M } from "./blocks/getPaymentDaysBlockById.query";
import { GET_PERSONALIZATION_BLOCK_BY_ID_M } from "./blocks/getPersonalizationBlockById.query";
import { GET_QUIZBLOCK_BY_ID_M } from "./blocks/getQuizBlockById.query";
import { GET_QUOTEBLOCK_BY_ID_M } from "./blocks/getQuoteBlockById.query";
import { GET_RESTRICTED_RICHTEXT_BLOCK_BY_ID_M } from "./blocks/getRestrictedRichTextBlockById.query";
import { GET_RICHTEXT_BLOCK_BY_ID_M } from "./blocks/getRichTextBlockById.query";
import { GET_SECTION_BLOCK_BY_ID_M } from "./blocks/getSectionBlockById.query";
import { GET_SHORTCUTS_BLOCK_BY_ID_M } from "./blocks/getShortCutBlockById.query";
import { GET_TABLE_BLOCK_BY_ID_M } from "./blocks/getTableBlockById.query";
import { GET_TEASER_BLOCK_BY_ID_M } from "./blocks/getTeaserBlockById.query";
import { GET_TEASER_LIST_BLOCK_BY_ID_M } from "./blocks/getTeaserListById.query";
import { GET_TEXT_LIST_BY_ID_M } from "./blocks/getTextListById.query";
import { GET_TIMELINE_BLOCK_BY_ID_M } from "./blocks/getTimelineBlockById.query";
import { GET_VIDEO_BLOCK_BY_ID_M } from "./blocks/getVideoBlockById.query";
import { GET_INFORMATION_BLOCK_BY_ID_M } from "./blocks/informationBlockById.query";
import { GET_LINK_BLOCK_BY_ID_M } from "./blocks/linkBlockById.query";
import { GET_EVENTPAGE_BY_ID_METHOD } from "./pages/getEventPageById.query";
import { GET_FAQPAGE_BY_ID_METHOD } from "./pages/getFaqPageById.query";
import { GET_INSURANCECLAIMPAGE_BY_ID_METHOD } from "./pages/getInsuranceClaimPageById.query";
import { GET_INSURANCEPAGE_BY_ID_METHOD } from "./pages/getInsurancePageById.query";
import { GET_LANDINGPAGE_BY_ID_METHOD } from "./pages/getLandingPageById.query";
import { GET_NEWSPAGE_BY_ID_METHOD } from "./pages/getNewsPageById.query";
import { GET_REPORTPAGE_BY_ID_METHOD } from "./pages/getReportPageById.query";
import { GET_STANDARDPAGE_BY_ID_METHOD } from "./pages/getStandardPageById.query";

export const getContentTypeQuery = (typename: string, id: any, preview: boolean) => {
  // eslint-disable-next-line sonarjs/max-switch-cases
  switch (typename?.toLowerCase()) {
    case "insurancepickerblock":
      return GET_INSURANCE_PICKER_BLOCK_BY_ID_M(id, preview);
    case "faq":
      return GET_FAQ_BLOCK_BY_ID_M(id, preview);
    case "accordionblock":
      return GET_ACCORDION_BLOCK_BY_ID_M(id, preview);
    case "personalizationblock":
      return GET_PERSONALIZATION_BLOCK_BY_ID_M(id, preview);
    case "sectionblock":
      return GET_SECTION_BLOCK_BY_ID_M(id, preview);
    case "page":
      return GET_PAGE_BY_ID_M(id, preview);
    case "teaserblock":
      return GET_TEASER_BLOCK_BY_ID_M(id, preview);
    case "videoblock":
      return GET_VIDEO_BLOCK_BY_ID_M(id, preview);
    case "fileblock":
      return GET_FILEBLOCK_BY_ID_M(id, preview);
    case "tableblock":
      return GET_TABLE_BLOCK_BY_ID_M(id, preview);
    case "richtextblock":
      return GET_RICHTEXT_BLOCK_BY_ID_M(id, preview);
    case "informationblock":
      return GET_INFORMATION_BLOCK_BY_ID_M(id, preview);
    case "timelineblock":
      return GET_TIMELINE_BLOCK_BY_ID_M(id, preview);
    case "contactblock":
      return GET_CONTACTBLOCK_BY_ID_M(id, preview);
    case "quizblock":
      return GET_QUIZBLOCK_BY_ID_M(id, preview);
    case "quoteblock":
      return GET_QUOTEBLOCK_BY_ID_M(id, preview);
    case "link":
      return GET_LINK_BLOCK_BY_ID_M(id, preview);
    case "restrictedrichtextblock":
      return GET_RESTRICTED_RICHTEXT_BLOCK_BY_ID_M(id, preview);
    case "shortcutsblock":
      return GET_SHORTCUTS_BLOCK_BY_ID_M(id, preview);
    case "listblock":
      return GET_LISTBLOCK_BY_ID_M(id, preview);
    case "faqlistblock":
      return GET_FAQLISTBLOCK_BY_ID_M(id, preview);
    case "formblock":
      return GET_FORM_BLOCK_BY_ID_M(id, preview);
    case "imageblock":
      return GET_IMAGE_BLOCK_BY_ID(id, preview);
    case "audience":
      return GET_AUDIENCES_M(id, preview);
    case "orderblock":
      return GET_ORDERBLOCK_BY_ID_M(id, preview);
    case "filelistblock":
      return GET_FILELISTBLOCK_BY_ID_M(id, preview);
    case "colorpaletteblock":
      return GET_COLOR_PALETTE_BLOCK_BY_ID_M(id, preview);
    case "teaserlistblock":
      return GET_TEASER_LIST_BLOCK_BY_ID_M(id, preview);
    case "paymentdaysblock":
      return GET_PAYMENTDAYSBLOCK_BY_ID_M(id, preview);
    case "bannerblock":
      return GET_BANNERBLOCK_BY_ID_M(id, preview);
    case "contactusblock":
      return GET_CONTACT_US_BLOCK_BY_ID_M(id, preview);
    case "linkteaserblock":
      return GET_LINK_TEASER_BLOCK_BY_ID_M(id, preview);
    case "textlist":
      return GET_TEXT_LIST_BY_ID_M(id, preview);
    default:
      return null;
  }
};

export const getPageType = (typename: string, id: any, preview: boolean) => {
  switch (typename?.toLowerCase()) {
    case "landingpage":
      return GET_LANDINGPAGE_BY_ID_METHOD(id, preview);
    case "standardpage":
      return GET_STANDARDPAGE_BY_ID_METHOD(id, preview);
    case "insurancepage":
      return GET_INSURANCEPAGE_BY_ID_METHOD(id, preview);
    case "insuranceclaimpage":
      return GET_INSURANCECLAIMPAGE_BY_ID_METHOD(id, preview);
    case "eventpage":
      return GET_EVENTPAGE_BY_ID_METHOD(id, preview);
    case "newspage":
      return GET_NEWSPAGE_BY_ID_METHOD(id, preview);
    case "reportpage":
      return GET_REPORTPAGE_BY_ID_METHOD(id, preview);
    case "faq":
      return GET_FAQPAGE_BY_ID_METHOD(id, preview);
    default:
      return GET_LANDINGPAGE_BY_ID_METHOD(id, preview);
  }
};
